// @flow
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Strong } from '@finect/tabular-core/Strong';
import { Icon } from '@finect/tabular-components/Icon';
import { QuestionBlock, QuestionInfo, Author, AnswerBlock, AnsweredBy, Adviser, AdviserCompany } from './partials';

type Props = {
  author?: string,
  question: string,
  adviser: {
    name: string,
    icon: string,
    subtype?: string,
    company: {
      name: string,
      icon: string
    } | null
  },
  url: string
};

export const Question = ({ author, question, adviser, url }: Props) => (
  <QuestionBlock data-fi-event="home-asesores" href={url}>
    <QuestionInfo>
      <Author>{author} pregunta:</Author>
      <Paragraph compact>{question}</Paragraph>
    </QuestionInfo>
    <AnswerBlock>
      <AnsweredBy align="center">
        <Icon alt={adviser.name} image={adviser.icon} type={adviser.company ? 'user' : 'company'} />
        <Adviser>
          <Strong>{adviser.name}</Strong>
          {adviser.company ? <AdviserCompany>{adviser.company.name}</AdviserCompany> : null}
        </Adviser>
      </AnsweredBy>
    </AnswerBlock>
  </QuestionBlock>
);
